"use strict";


const cPost = 'qam_AGL/mcX-sKQ'
const cGet = 'uV9_0vH/Amn-mba'
const cPut = 'jqs_sBu/e1E-kbd'
const cDel = 'FD1_LPa/zz8-GeZ'



exports.endpointCodes  = {
      post: cPost,
      get: cGet,
      put: cPut,
      del: cDel
}


const local ='http://localhost:3338'
const cpanel ='https://davisindgroup.com' // cambiar por la url del sitio web.

exports.url  =  cpanel + '/api/gfE_leg/M3b-95d'; 

exports.normalize = (function() {
      var from = "ÃÀÁÄÂÈÉËÊÌÍÏÎÒÓÖÔÙÚÜÛãàáäâèéëêìíïîòóöôùúüûÑñÇç", 
          to   = "AAAAAEEEEIIIIOOOOUUUUaaaaaeeeeiiiioooouuuunncc",
          mapping = {};
     
      for(var i = 0, j = from.length; i < j; i++ )
          mapping[ from.charAt( i ) ] = to.charAt( i );
     
      return function( str ) {
          var ret = [];
          for( var i = 0, j = str.length; i < j; i++ ) {
              var c = str.charAt( i );
              if( mapping.hasOwnProperty( str.charAt( i ) ) )
                  ret.push( mapping[ c ] );
              else
                  ret.push( c );
          }      
          return ret.join( '' ).replace( /[^-A-Za-z0-9]+/g, '-' ).toLowerCase();
      }
     
})();